import StyledTreeItemVertical from "./StyledTreeItemVertical";

const RenderTreeVertical = (props) => {
    const {sourceData, childrenKey, rootItem, childItem, parentPath, onDoubleClick} = props;

    return (
        (sourceData[childrenKey] || []).map((item, index) => {
            const path = parentPath ? parentPath + `.children.${index}` : `children.${index}`;
            if(item[childrenKey]){
                return (
                    <StyledTreeItemVertical
                        nodeId={path}
                        component={rootItem}
                        doc={item}
                        onDoubleClick={onDoubleClick}
                    >
                        {RenderTreeVertical({
                            sourceData: item,
                            childrenKey,
                            rootItem,
                            childItem,
                            parentPath: path,
                            onDoubleClick
                        })}
                    </StyledTreeItemVertical>
                )
            }
            return (
                <StyledTreeItemVertical
                    nodeId={path}
                    component={childItem}
                    doc={item}
                    onDoubleClick={onDoubleClick}
                />
            )
        })
    )
}

export default RenderTreeVertical;
